/** @format */
import angular from 'angular';
import jsData from 'js-data-angular';

defineResource.$inject = ['DS', '$http'];

export const honoraryTitleModule = 'sis-components.model.honoraryTitle';

angular.module(honoraryTitleModule, [jsData]).factory('honoraryTitleJSDataModel', defineResource);

function defineResource(DS, $http) {
    const model = DS.defineResource({
        idAttribute: 'urn',
        name: 'honoraryTitle',
        endpoint: '/kori/api/cached/codebooks/urn:code:honorary-title',
    });
    model.lazyGetAll = _.once(function () {
        return $http.get(model.endpoint).then(function (response) {
            model.inject(_.values(response.data));
            return model.getAll();
        });
    });
    return model;
}
